export default "__VITE_ASSET__2PoacZ1g__"